module.exports = "<table mat-table [fxShow]=\"hasData\"\n           [dataSource]=\"dataSource\">\n    <ng-content></ng-content>\n</table>\n"